export default __webpack_public_path__ + "static/media/loginPic.49ac337a.jpg";